import isEmpty from "lodash.isempty";
import omit from "lodash.omit";
import qs from "qs";

import { allowedQueryFilters } from "../../stores/FiltersStore";
import defaultSearchFields from "../helpers/defaultSearchFields";
import getQueryString from "../helpers/getQueryString/getQueryString";
import pick from "../helpers/pick/pick";

const normalizeFieldConfiguration = (fields) =>
  Array.isArray(fields)
    ? fields.map((field) => ({
        field: field?.field,
        placeholder: field?.placeholder,
      }))
    : undefined;

const normalizeFieldConfigurationNested = (fields) =>
  Array.isArray(fields)
    ? fields.map((field) => ({
        field: field?.field,
        placeholder: field?.placeholder,
      }))
    : undefined;

function useFilters(isNested) {
  const handleSubmit = (
    router,
    resultsUrl,
    filters = [],
    filterFields = [],
    params = {}
  ) => {
    const fieldsConfiguration = isNested
      ? normalizeFieldConfigurationNested(filterFields)
      : normalizeFieldConfiguration(filterFields);

    const fields =
      Array.isArray(fieldsConfiguration) && !isEmpty(fieldsConfiguration)
        ? fieldsConfiguration
        : defaultSearchFields;

    const selectedFilters = fields.map(({ field }) => field);
    const mergedFilters = pick(filters, selectedFilters);

    const queryString = getQueryString(mergedFilters);

    const queryObject = qs.parse(queryString);

    const routerQueryObject = omit(params, allowedQueryFilters);

    const isCustomUrlUsed = !isEmpty(resultsUrl);

    const mergedQuery = { ...routerQueryObject, ...queryObject };

    const query = getQueryString(isCustomUrlUsed ? queryObject : mergedQuery);

    router.push(
      {
        pathname: resultsUrl,
        query,
      },
      undefined,
      { scroll: false }
    );
  };

  return { handleSubmit };
}

export default useFilters;
